import React from 'react';
import { Dialog, Stack, Grid, Box } from '@mui/material';
import { 
  CustomDialogTitle, 
  CustomDialogAction, 
  StyledCard, 
  CustomDialogContent, 
  CustomButton 
} from 'custom/components';
import { CloseIconBtn } from 'custom/constants';
import InputSelectField from 'custom/InputSelectField';
import InputTextField from 'custom/InputTextField';


const AccountingInfoModal = (props) => {

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'accountingInformation'} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          Add Accounting Information
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        
        <Box component='form' >
          <CustomDialogContent>
            <StyledCard>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={3}>
                  <InputSelectField
                    label='Select Identifier'
                    // value={''}
                    // onChange={() => {}}
                    options={[
                      'GEN (General Information)',
                      'MCO (Miscellaneous Charge Order)',
                      'SRN (Shipper\'s Reference Number)',
                      'STL (Mode of Settlement)'
                    ]}
                    fullWidth

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={9}>
                  <InputTextField
                    label='Information'
                    // value={}
                    // onChange={}
                  />
                </Grid>
              </Grid>
            </StyledCard>
          </CustomDialogContent>

          <CustomDialogAction>
            <Stack direction='row' justifyContent='space-between' spacing={2} width={'100%'}>
              <CustomButton variant='contained' type='reset'> Close </CustomButton> 
              <CustomButton variant='contained'> Update </CustomButton> 
            </Stack>
          </CustomDialogAction>
        </Box>
      </Dialog>

    </div>
  );
};
export default AccountingInfoModal;